import { ChangeDetectionStrategy, Component, OnInit, inject, signal } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Container } from '../../../core/containers/container';
import { LoadingService } from '../../../core/services/loading.service';
import { RolesService } from '../../../core/services/roles/roles.service';
import { SettingsService } from '../../../core/services/settings/settings.service';
import { Apollo } from 'apollo-angular';
import { environment } from 'src/environments/environment';
import * as fromGraphQl from './graphql';

@Component({
  selector: 'app-general-settings',
  templateUrl: './general-settings.component.html',
  styleUrls: ['./general-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    'class': 'general-settings'
  },
})
export class GeneralSettingsComponent
  extends Container<fromGraphQl.SettingsQueryResponse>
  implements OnInit
{
  // Injected services
  readonly rolesService = inject(RolesService);
  readonly settingsService = inject(SettingsService);

  readonly settings = signal<fromGraphQl.SettingCategory[] | null>(null);
  readonly isEditable = signal(false);
  form: UntypedFormGroup;

  constructor() {
    super(inject(Apollo), inject(LoadingService), fromGraphQl.SETTINGS_QUERY, environment);
  }

  ngOnInit(): void {
    this.subscribeToQuery();
  }

  handleSubscriptionResult(data: fromGraphQl.SettingsQueryResponse): void {
    this.settings.set(data?.terms);
    this.form = this.settingsService.createSettingsFormGroup(data?.terms);
    if (!this.isEditable()) {
      this.form.disable();
    }
  }

  save(key: string, value: any): void {
    const settingInput = { key, value };
    this.settingsService.updateSettings(settingInput, () => {});
  }

  abortEditSettings(): void {
    this.isEditable.set(false);
    this.subscribeToQuery();
  }

  updateSettings(): void {
    Object.keys(this.form.controls).forEach((name) => {
      const currentControl = this.form.controls[name];
      if (currentControl.dirty) {
        this.save(name, currentControl?.value);
      }
    });
    this.isEditable.set(false);
    this.form.disable();
  }

  editSettings(): void {
    this.form?.enable();
    this.isEditable.set(true);
  }

  onFileChanged(): void {
    this.queryRef?.refetch();
  }

}
